import { Checkbox, Input, Select } from "components"
import { useProductCategory } from "pages/Inventori/Register/utils"
import { FilterTypeSetStockGlobal } from "pages/Inventori/Transaction/SetStockGlobal/types/SetStockGlobalTypes"

type Props = {
    filter: FilterTypeSetStockGlobal
    setFilter: React.Dispatch<React.SetStateAction<FilterTypeSetStockGlobal>>
    showMinus: boolean
    setShowMinus: (v: boolean) => void
    showPlus: boolean
    setShowPlus: (v: boolean) => void
  }

export function Filter({ filter, setFilter, showMinus, setShowMinus, showPlus, setShowPlus }: Props) {

    // hooks
    const { dataCategory, isLoadingCategory } = useProductCategory();

    return (
        <div className="lg:flex lg:justify-between items-start mb-5">
            <div className="flex flex-col gap-5 mb-2">
                <div>
                    <Input
                        label="SEARCH"
                        className="lg:w-[300px] md:w-full"
                        placeholder="Search data..."
                        onChange={res => {
                            setFilter({ ...filter, keyword: res.target.value })
                        }}
                    />
                </div>
                <div className="flex items-center gap-3">
                    <Checkbox
                        defaultChecked={filter?.buy}
                        onChange={(e) =>
                            setFilter({
                                ...filter,
                                buy: e.target.checked ?? "",
                            })
                        }
                    >
                        BUY
                    </Checkbox>

                    <Checkbox
                        defaultChecked={filter?.sell}
                        onChange={(e) =>
                            setFilter({
                                ...filter,
                                sell: e.target.checked ?? "",
                            })
                        }
                    >
                        SELL
                    </Checkbox>

                    <Checkbox
                        defaultChecked={filter?.inv}
                        onChange={(e) =>
                            setFilter({
                                ...filter,
                                inv: e.target.checked ?? "",
                            })
                        }
                    >
                        INVENTORY
                    </Checkbox>

                    <Checkbox
                        defaultChecked={filter?.build}
                        onChange={(e) =>
                            setFilter({
                                ...filter,
                                build: e.target.checked ?? "",
                            })
                        }
                    >
                        BUILD
                    </Checkbox>
                </div>
            </div>

            <div className="flex flex-col gap-5">
                <div className="lg:flex gap-2">
                    <Select
                        label="CATEGORY"
                        placeholder="Select product category here..."
                        className="lg:w-[200px] w-full me-2 mb-2"
                        width={true}
                        defaultValue={{ value: "0", label: "All" }}
                        isLoading={isLoadingCategory}
                        options={[{ label: "All", value: "" }].concat(
                            dataCategory
                        )}
                        value={dataCategory.find(
                            (item) => item.value === filter?.category_id
                        )}
                        onChange={(e) =>
                            setFilter({
                                ...filter,
                                category_id: e?.value ?? "",
                            })
                        }
                    />

                </div>

                <div className="flex items-center gap-3">
                    <Checkbox
                        defaultChecked={filter?.zero_soh}
                        onChange={(e) =>
                            setFilter({
                                ...filter,
                                zero_soh: e.target.checked ?? "",
                            })
                        }
                    >
                        <div className="whitespace-nowrap">Zero SOH</div>
                    </Checkbox>

                    <Checkbox
                        value={showMinus}
                        onChange={(e) => setShowMinus(e.target.checked)}
                    >
                        Minus
                    </Checkbox>

                    <Checkbox
                        value={showPlus}
                        onChange={(e) => setShowPlus(e.target.checked)}
                    >
                        Plus
                    </Checkbox>
                </div>
            </div>
        </div>
    )
}
